/**
 * @flow
 * @relayHash 5a5ca75b618632ed0d00e98f72805954
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getSettingsQueryVariables = {|
  orgId: string,
  propertyId?: ?string,
|};
export type getSettingsQueryResponse = {|
  +hyeventsSetting: {|
    +approvalRequired: boolean,
    +approverEmails: $ReadOnlyArray<string>,
    +agentApprovalEmails: $ReadOnlyArray<string>,
    +hyeventsBccEmails: ?$ReadOnlyArray<string>,
  |}
|};
export type getSettingsQuery = {|
  variables: getSettingsQueryVariables,
  response: getSettingsQueryResponse,
|};
*/


/*
query getSettingsQuery(
  $orgId: ID!
  $propertyId: ID
) {
  hyeventsSetting(orgId: $orgId, propertyId: $propertyId) {
    approvalRequired
    approverEmails
    agentApprovalEmails
    hyeventsBccEmails
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "orgId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "propertyId",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "orgId",
    "variableName": "orgId"
  },
  {
    "kind": "Variable",
    "name": "propertyId",
    "variableName": "propertyId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approvalRequired",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approverEmails",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "agentApprovalEmails",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hyeventsBccEmails",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getSettingsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyeventsSetting",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "HyeventsSetting",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "getSettingsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyeventsSetting",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "HyeventsSetting",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "getSettingsQuery",
    "id": null,
    "text": "query getSettingsQuery(\n  $orgId: ID!\n  $propertyId: ID\n) {\n  hyeventsSetting(orgId: $orgId, propertyId: $propertyId) {\n    approvalRequired\n    approverEmails\n    agentApprovalEmails\n    hyeventsBccEmails\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a1b95a768930d4f546cdafeb4a94344a';
module.exports = node;
